import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Input } from '../ui/input';
import { methodologyService, Methodology, GuidedMethodology } from '../../lib/firebase';

interface MethodologyPickerModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (methodology: Methodology | GuidedMethodology) => void;
}

const MethodologyPickerModal: React.FC<MethodologyPickerModalProps> = ({ open, onClose, onSelect }) => {
  const [methodologies, setMethodologies] = useState<(Methodology | GuidedMethodology)[]>([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    let unsub: (() => void) | undefined;
    (async () => {
      const straightUp = (await methodologyService.getMethodologies?.() || []).filter((m: any) => {
        // If there is a status or approved property, filter accordingly
        if (typeof m.status === 'string' && m.status !== 'Active') return false;
        if (typeof m.approved === 'boolean' && !m.approved) return false;
        return true;
      });
      const guided = (await methodologyService.getGuidedMethodologies?.() || []).filter((m: any) => m.status === 'Active');
      setMethodologies([...straightUp, ...guided]);
    })();
    return () => { if (unsub) unsub(); };
  }, []);

  const filtered = methodologies.filter(m =>
    m.title?.toLowerCase().includes(search.toLowerCase()) ||
    (m.name?.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg w-full" aria-describedby="methodology-picker-description">
        <DialogHeader>
          <DialogTitle>Select a Methodology</DialogTitle>
          <DialogDescription id="methodology-picker-description">
            Search and select a methodology to attach to this board column.
          </DialogDescription>
        </DialogHeader>
        <Input
          placeholder="Search methodologies..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="mb-4"
        />
        <div className="max-h-80 overflow-y-auto space-y-2">
          {filtered.map(m => (
            <div
              key={m.id}
              className="p-3 border rounded-md cursor-pointer hover:bg-gray-50"
              onClick={() => { onSelect(m); onClose(); }}
            >
              <div className="font-medium">{m.title || m.name}</div>
              <div className="text-xs text-gray-500">{m.description}</div>
            </div>
          ))}
          {filtered.length === 0 && <div className="text-gray-400">No methodologies found.</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { MethodologyPickerModal };
export default MethodologyPickerModal; 